document.addEventListener('DOMContentLoaded', function () {
  const mapElement = document.getElementById('origin-map');
  if (!mapElement) return;

  const currentProductId = mapElement.dataset.currentProductId;
  const productsData = JSON.parse(document.getElementById('products-data').textContent);

  // Standaard inzoomen op Azië
  const center = [30, 100];
  const bounds = [[5, 60], [50, 145]];

  const map = L.map('origin-map').setView(center, 4);

  // Gebruik een grijze tile-laag (CartoDB Positron)
  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    maxZoom: 20
  }).addTo(map);

  const markers = L.markerClusterGroup({
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    spiderfyDistanceMultiplier: 1.5
  });

  let currentMarker = null;
  let closePopupTimeout = null;

  productsData.forEach(product => {
    const latRaw = product.latitude;
    const lngRaw = product.longitude;

    if (!latRaw || !lngRaw) return;

    const lat = parseFloat(String(latRaw).replace(',', '.'));
    const lng = parseFloat(String(lngRaw).replace(',', '.'));

    if (isNaN(lat) || isNaN(lng)) return;

    const marker = L.circleMarker([lat, lng], {
      radius: 6,
      fillColor: '#F7931A',
      fillOpacity: 0.8,
      color: '#F7931A',
      weight: 1
    });

    const popupContent = `
      <div>
        <a href="${product.url}">
          <img src="${product.image}" alt="${product.title}" />
        </a>
        <p><strong>${product.title}</strong></p>
        <p>${product.herkomst}</p>
      </div>
    `;
    marker.bindPopup(popupContent);

    marker.on('mouseover', function () {
      // Annuleer een eventueel lopende sluiting
      if (closePopupTimeout) {
        clearTimeout(closePopupTimeout);
        closePopupTimeout = null;
      }
      this.openPopup();
    });

    marker.on('mouseout', function () {
      // Voeg een vertraging van 500ms toe voordat de popup sluit
      const marker = this;
      closePopupTimeout = setTimeout(() => {
        marker.closePopup();
        closePopupTimeout = null;
      }, 500);
    });

    // Zorg ervoor dat de popup niet sluit als je op de afbeelding klikt
    marker.on('popupopen', function () {
      const popup = this.getPopup();
      const popupElement = popup.getElement();
      const link = popupElement.querySelector('a');
      if (link) {
        link.addEventListener('mouseover', () => {
          if (closePopupTimeout) {
            clearTimeout(closePopupTimeout);
            closePopupTimeout = null;
          }
        });
        link.addEventListener('mouseout', () => {
          closePopupTimeout = setTimeout(() => {
            marker.closePopup();
            closePopupTimeout = null;
          }, 500);
        });
      }
    });

    if (product.id == currentProductId) {
      currentMarker = marker;
      marker.on('add', () => marker.openPopup());
    }

    markers.addLayer(marker);
  });

  map.addLayer(markers);

  if (currentMarker) {
    map.setView(currentMarker.getLatLng(), 4);
    currentMarker.openPopup();
  }

  map.fitBounds(bounds);
});